import React from 'react'
import { Button, CircularProgress, Box } from '@material-ui/core'

export default function PrimaryButtton(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { children, onClick, startIcon, fullWidth, loading, type } = props

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  if (loading) {
    return (
      <Button variant="contained" color="primary" fullWidth={fullWidth} disabled>
        <Box pt={1}>
          <CircularProgress color="inherit" size="1rem" />
        </Box>
      </Button>
    )
  }

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      startIcon={startIcon}
      fullWidth={fullWidth}
      type={type}
    >
      {children}
    </Button>
  )
}
